// import { serialize, deserialize } from '@storeOld/state'

// We are using serialization in order to compress snapshot

// @todo review
const serialize = (snapshot: any) => {
  return JSON.stringify(snapshot)
}
const deserialize = (serializedSnapshot: string) => {
  return JSON.parse(serializedSnapshot)
}

class History<SerializedSnapshot = unknown, Snapshot = unknown> {
  private serializedSnapshots: SerializedSnapshot[] = []

  private currentIndex = 0

  private backupIndex: number | undefined = undefined

  serialize = (snapshot: Snapshot): SerializedSnapshot =>
    serialize(snapshot) as SerializedSnapshot

  deserialize = (serializedSnapshot: SerializedSnapshot) =>
    deserialize(serializedSnapshot as string) as Snapshot

  getSerializedSnapshot = (): SerializedSnapshot => {
    return this.serializedSnapshots[this.currentIndex]
  }

  getSnapshot = (): Snapshot => {
    return this.deserialize(this.getSerializedSnapshot())
  }

  isUndoAvailable = (): boolean => this.currentIndex > 0

  isRedoAvailable = (): boolean =>
    this.currentIndex < this.serializedSnapshots.length - 1

  isRollbackAvailable = (): boolean => this.backupIndex !== undefined

  resetToSnapshot = (snapshot: Snapshot) => {
    this.serializedSnapshots = [this.serialize(snapshot)]
    this.currentIndex = 0
    this.backupIndex = undefined
  }

  push = (snapshot: Snapshot) => {
    this.serializedSnapshots = [
      ...this.serializedSnapshots.slice(0, this.currentIndex + 1),
      this.serialize(snapshot),
    ]
    this.currentIndex++
  }

  resetToIndex = (index: number) => {
    this.currentIndex = index
  }

  undoToTheStart = () => {
    this.resetToIndex(0)
  }

  undo = () => {
    if (this.isUndoAvailable()) {
      this.resetToIndex(this.currentIndex - 1)
    }
  }

  redo = () => {
    if (this.isRedoAvailable()) {
      this.resetToIndex(this.currentIndex + 1)
    }
  }

  saveBackupSnapshot = () => {
    this.backupIndex = this.currentIndex
  }

  rollbackToBackup = () => {
    if (this.isRollbackAvailable()) {
      this.currentIndex = this.backupIndex!
    }
  }
}

export default History
